(() => {
  const selector = '[data-deferred-animation]';

  const loadAnimation = (media) => {
    const source = media.dataset.animatedSrc;
    if (!source) return;
    media.src = source;
    media.removeAttribute('data-animated-src');
    media.removeAttribute('data-deferred-animation');

    if (media instanceof HTMLVideoElement) {
      media.load();
      const playback = media.play();
      if (playback) playback.catch(() => {});
    }
  };

  const initialize = (root = document) => {
    const images = [...root.querySelectorAll(selector)];
    if (!images.length || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    if (!('IntersectionObserver' in window)) {
      images.forEach(loadAnimation);
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        loadAnimation(entry.target);
      });
    }, { rootMargin: '100px 0px' });

    images.forEach((media) => {
      observer.observe(media);
      media.addEventListener('click', () => loadAnimation(media), { once: true });
      media.addEventListener('keydown', () => loadAnimation(media), { once: true });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  } else {
    initialize();
  }

  if (!window.__swaravoDeferredAnimationEditorListener) {
    window.__swaravoDeferredAnimationEditorListener = true;
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  }
})();
